module.exports = __webpack_public_path__ + "img/img-60a893.png";